// extracted by mini-css-extract-plugin
module.exports = {"container":"e_aq","title":"e_bq","titleIcon":"e_cq","summary":"e_dq","sourcesTitle":"e_eq","sources":"e_fq","source":"e_gq"};